












































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { ICompany, IParticipation, ITenant } from '@/types/types'

import CardCompany from '@/components/CardCompany.vue'
import CardSelectTenant from '@/components/CardSelectTenant.vue'
import TableTenantUsers from '@/components/TableTenantUsers.vue'

import { findCompany, resendCompanyInvites } from '@/services/company'
import { findUsers, sendInvite } from '@/services/users'

const USERS_TENANT = 'users:tenant'

const setCurrentTenantStorage = (tenant: ITenant) =>
  (sessionStorage[USERS_TENANT] = JSON.stringify(tenant))

const getCurrentTenant: () => ITenant = () =>
  sessionStorage[USERS_TENANT] ? JSON.parse(sessionStorage[USERS_TENANT]) : {}

@Component({
  components: { CardSelectTenant, TableTenantUsers, CardCompany },
})
export default class Users extends Vue {
  tenant: ITenant = getCurrentTenant()
  company: ICompany | object = {}
  participation: IParticipation | object = {}
  users: any = []
  loadingCompany = false
  loadingUsers = false
  activeTab = 0

  async refreshCompany() {
    try {
      if (!this.tenant || !this.tenant.tenantName) {
        this.company = {}
        this.participation = {}
        return false
      }
      this.loadingCompany = true
      const { company, participation } = await findCompany(
        this.tenant.tenantName
      )
      this.company = company || {}
      this.participation = participation || {}
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha ao carregar os dados dessa conta',
        type: 'is-danger',
      })
    } finally {
      this.loadingCompany = false
    }
  }

  updateCompany(company: ICompany) {
    this.company = company
  }

  async findUsers() {
    try {
      this.loadingUsers = true
      this.users = this.tenant.tenantName
        ? await findUsers(this.tenant.tenantName)
        : []
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha ao carregar os usuários dessa conta',
        type: 'is-danger',
      })
    } finally {
      this.loadingUsers = false
    }
  }

  resendCompanyInvites() {
    return (
      this.tenant.tenantName && resendCompanyInvites(this.tenant.tenantName)
    )
  }

  onTenantSelected(tenant: ITenant) {
    setCurrentTenantStorage(tenant)
    this.tenant = tenant
  }

  @Watch('tenant', { immediate: false, deep: true })
  onTenantChange(tenant: any) {
    this.refreshCompany()
    this.findUsers()
  }

  onClean() {
    this.users = []
    this.tenant = {}
    setCurrentTenantStorage({})
  }

  onSendInvite({ tenantName, email }: any) {
    sendInvite(tenantName, [email])
  }

  setLoading(value: boolean) {
    const card = this.$refs.cardSelectTenant as CardSelectTenant
    card.setLoading(value)
  }

  mounted() {
    this.tenant = getCurrentTenant()
  }
}
